<template>
	<div class="space-overview-container">
		<div class="row tool-wrapper">
			<div class="col">
				<button class="my-btn" @click="showDeleteSpaceModal = true">Delete space</button>
				<button class="my-btn" @click="saveSpace">Save Space</button>
			</div>
			<div class="col"><h1 class="view-title">{{space.title}}</h1></div>
			<div class="col">
				<button class="my-btn" @click="showBackHomeModal = true">Exit Space</button>
			</div>
		</div>

		<modal v-if="showAddNodeModal" :withOkBtn="true" :withCancelBtn="true" @close="showAddNodeModal = false" @ok="addNode">
			<div slot="header">Add new step</div>
			<div slot="body">
				<div class="form-group">
					<input class="form-input" type="text" v-model="newNodeTitle" placeholder="Edit Title">
				</div>
				<div class="form-group">
					<textarea class="form-input" type="text" v-model="newNodeDescription" placeholder="Add a small description" rows="5"></textarea>
				</div>
			</div>
		</modal>

		<modal v-if="showSaveSpaceModal" :withOkBtn="true" :withCancelBtn="false" @ok="showSaveSpaceModal = false">
			<div slot="header">Save space</div>
			<div slot="body">
				Your new space is saved.
			</div>
		</modal>

		<modal v-if="showBackHomeModal" :withOkBtn="true" :withCancelBtn="true" @ok="backToHome" @close="showBackHomeModal = false">
			<div slot="header">Back to homepage</div>
			<div slot="body">
				Save new space and go back to home page?
			</div>
		</modal>

		<modal v-if="showDeleteSpaceModal" :withOkBtn="true" :withCancelBtn="true" @ok="deleteSpace" @close="showDeleteSpaceModal = false">
			<div slot="header">Delete space</div>
			<div slot="body">
				Are you sure you want to delete this space?
			</div>
		</modal>
		
		<space-flowchart @editTitle="editTitle" :height="800"></space-flowchart>
	</div>
</template>

<script>
	import SpaceFlowchart from '@/components/SpaceFlowchart.vue'
	import Modal from '@/components/modals/Modal'
	import {mapGetters} from 'vuex'

	export default {
		name: 'SpaceOverview',
		components: {
			SpaceFlowchart,
			'modal': Modal
		},
		computed: {
			...mapGetters(['space', 'allSpaces'])
		},
		data() {
			return {
				showAddNodeModal: false,
				showSaveSpaceModal: false,
				showBackHomeModal: false,
				showDeleteSpaceModal: false,
				newNodeTitle: '',
				newNodeDescription: ''
			}
		},
		methods: {
			canvasClick(e) {
				console.log('canvas Click, event:', e);
			},
			editTitle(node) {
				let editedNode = this.scene.nodes.filter(function(el){
					return el.id == node.id;
				}.bind(this))[0];
				editedNode.title = node.title;
				editedNode.description = node.description;
			},
			saveSpace() {
				return new Promise((resolve,reject) => {
					this.$store.dispatch({
						'type': 'saveSpace',
						'spaceObj': this.space
					}).then(response => {
						this.showSaveSpaceModal = true;
						resolve();
					});
				});
			},
			backToHome() {
				this.showBackHomeModal = false;
				this.saveSpace().then(response => {
					this.$router.push({path: '/'});
				});
			},
			deleteSpace() {
				this.showDeleteSpaceModal = false;
				this.$store.dispatch({
					'type': 'deleteSpace',
					'spaceObj': this.space
				}).then(response => {
					this.$router.push({path: '/'});
				});
			}
		}
	}
</script>

<style scoped>
	.space-overview-container {
		text-align: center;
		margin: 0;
		overflow: hidden;
		height: 100%;
		padding-top: 80px;
	}
</style>